import React, { useEffect, useRef } from "react";
import Button from "../../ui/Button";
import "./file-upload.css";

export default function FileUpload({
  label,
  name,
  value,
  onChange,
  error,
  accept = "image/*,.pdf",
  required,
  previewInline = false,
}) {
  const fileRef = useRef(null);

  useEffect(() => {
    if (!value && fileRef.current) {
      fileRef.current.value = "";
    }
  }, [value]);

  const handleClick = () => {
    fileRef.current?.click();
  };

  const isFileObject = value instanceof File;
  const isUrlValue = typeof value === "string" && value.trim() !== "";
  const isImageFile = isFileObject && value.type?.startsWith("image/");
  const isImageUrl =
    isUrlValue &&
    /\.(jpg|jpeg|png|gif|webp|bmp|svg)(\?.*)?$/i.test(value);

  const fileName = isFileObject
    ? value.name
    : isUrlValue
    ? value.split("?")[0].split("/").pop()
    : null;

  return (
    <div className={previewInline ? "file-upload file-upload-row" : "file-upload"}>
      
      {label && (
        <label htmlFor={name} className="text-sm fw-medium">
          {label} {required && "*"}
        </label>
      )}

      {/* Hidden Input */}
      <input
        type="file"
        name={name}
        ref={fileRef}
        onChange={onChange}
        accept={accept}
        hidden
      />

      <div className="file-upload-controls">
        <Button type="button" onClick={handleClick}>
          Choose File
        </Button>

        <span className="file-upload-name">
          {fileName || "No file chosen"}
        </span>
      </div>

      {(isImageFile || isImageUrl) && (
        <div className="file-upload-preview-frame">
          <img
            src={isImageFile ? URL.createObjectURL(value) : value}
            alt="preview"
            className="file-upload-preview"
          />
        </div>
      )}

      {/* Error */}
      {error && (
        <span className="text-danger text-xs">{error}</span>
      )}
    </div>
  );
}